<div class="modal-content page-wrapper">
  <div class="modal-header">
    <button class="close" (click)="close()"><i class="fa fa-close"></i></button>
  </div>
  <div class="modal-body">
    <div class="content-block">
      <h2>Terms and Conditions</h2>
      <div class="card">
        <div class="row">
          <div class="col-12">
            <p class="small-text">
              The following terms and conditions (“<b>Terms</b>”) govern all products and services offered on the Facility (defined below)
              by the Capital Alliance Group of Companies (including, but not limited to, Capital Alliance Securities (Private) Limited,
              Capital Alliance Investments Limited, Capital Alliance PLC, Capital Alliance Partners Limited, Fipbox (Pvt) Ltd)
              (“<b>CAL</b>”, “<b>us</b>” or “<b>the company</b>”).
            </p>
            <p class="heading">
              <b>BY ACCESSING AND USING THE CAL PORTAL AND/OR CAL ONLINE</b> ONLINE (via web and/or mobile apps)(“<b>Facility</b>”), you
              agree to be bound by the Terms. “You”, “your” refers to the person(s) that has agreed to use the Facility in accordance with
              the Terms and in the event of joint account holders, to all holders jointly and severally.
            </p>
          </div>
        </div>

        <div class="vert-scroll">
          <div class="row">
            <div class="col-12">
              <ol class="increment-list">
                <li>
                  <p>
                    <b> SHARING INFORMATION WITH THIRD PARTIES</b><br />
                    You consent to:
                  </p>
                  <ol class="sub">
                    <li>
                      <b>receiving communications </b> related to CAL’s products and services
                      <b>from CAL or third-party service providers/intermediaries engaged by CAL in connection with the Facility; </b>
                    </li>
                    <li>
                      <b>to the</b> sharing of your information <b>with</b> such third-party service providers/intermediaries to the extent
                      necessary for them to provide such services;
                    </li>
                    <li>
                      the verification of your identity and authentication of any data or document furnished by you to us (including but not
                      limited to your name, address, date of birth, National Identity Card number and image) with the Department of the
                      Registration of Persons via any IT system or facility maintained by the said Department;
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    <b>CUSTOMER OBLIGATIONS</b>
                  </p>
                  <ol class="sub">
                    <li>
                      You will not disclose the user ID/Password/Personal Identity No. (PIN) required to use this Facility to anyone and you
                      shall treat such information as strictly confidential. Upon becoming aware of such information falling into the hands
                      of an unauthorized person, you will immediately report it to CAL.
                    </li>
                    <li>
                      You accept full responsibility for all transactions processed from the use of the Facility including, the accuracy of
                      the information submitted through the Facility and adherence to all applicable laws in relation to any services
                      received through the Facility.
                    </li>
                    <li>You accept CAL’s record of transactions as conclusive and binding for all purposes.</li>
                  </ol>
                </li>

                <li>
                  <p>
                    <b>ELECTRONIC CONTRACTS</b>
                  </p>
                  <ol class="sub">
                    <li>
                      Placing your electronic signature in accordance with the specific procedures set out below (hereafter referred to as
                      "E-Signature"), signifies your <b>intent</b> to be bound by the terms and conditions therein and create a legally
                      binding contract (“<b>Electronic Contract</b>”). You understand and agree that your electronic signature is the legal
                      equivalent of your manual signature under and in terms of the applicable law.
                    </li>
                    <li>
                      You agree that no certification authority or other third-party verification is necessary to validate your E-Signature
                      and that the lack of such certification or third-party verification will not in any way affect the enforceability of
                      your E-Signature or any resulting contract between you and CAL.
                    </li>
                    <li>
                      Notwithstanding the placement of your E-Signature, the said contract shall be valid and binding only upon the
                      execution of the same by CAL. Nothing stated herein or in the Electronic Contract shall be considered binding on CAL
                      to enter into such Electronic Contract. You understand that the
                      <b>entering into of such contract shall, be CONDITIONAL on CAL completing all legal and regulatory requirements</b>
                      including, KYC checks to our satisfaction.
                    </li>
                  </ol>
                </li>

                <li>
                  <p><b>INDEMNITY</b></p>
                  <ol class="sub">
                    <li>
                      CAL is authorized to accept instructions from you or your duly authorized representative via electronic mail
                      (“E-Mail”) or via the Facility with regard to any matters or transactions whatsoever notwithstanding the fact that the
                      identity of the person giving/sending any such E-Mail cannot be authenticated by CAL.
                    </li>
                    <li>
                      Any Instruction via E-Mail or via the Facility which appears to CAL to originate from you or your authorized
                      representative shall be conclusively presumed for the company’s benefit to be duly authorized by and legally binding
                      on you, and you shall be fully responsible for the same. You shall ensure that sufficient safeguards are in place to
                      protect the integrity and security of your computer systems and e-mail to prevent unauthorized E-Mails being sent.
                    </li>
                    <li>
                      CAL shall not be responsible for ensuring the authenticity, validity or source of any instruction and shall not be
                      liable for any instruction that is subsequently discovered to be unauthorized, erroneous or fraudulent.
                    </li>

                    <li>
                      You acknowledge and agree that, until such time as CAL acknowledges your E-Mail instructions by return mail, your
                      instructions shall not be deemed delivered and CAL shall have no liability for errors delays or losses caused as a
                      result thereof.
                    </li>

                    <li>
                      Notwithstanding anything contained herein, CAL may, at its absolute discretion, refuse to accept and act on any E-Mail
                      and request for a written confirmation of any such E-Mail instruction signed by you or your authorized representative
                      and you shall submit such confirmation to the company immediately upon receipt of the request.
                    </li>
                    <li>
                      CAL shall not be liable to you or any third party for, and you shall indemnify the company at all times against, any
                      loss, damage, claim, expense or liability, whether involving fraud or not, and whether arising in contract, tort or
                      otherwise, howsoever in connection with any E-Mail or any instructions that appear to be provided by you over the
                      Facility.
                    </li>
                  </ol>
                </li>

                <li>
                  <p>
                    <b>LIMITATION OF LIABILITY</b>
                  </p>
                  <ol class="sub">
                    <li>
                      In the event the E-Signature appears to be originating from you it shall be conclusively presumed for CAL’s benefit to
                      be duly authorized by and legally binding on you. You shall ensure that sufficient safeguards are in place to protect
                      the integrity and security of your systems and E-mail to prevent unauthorized use of your E-Signature. CAL shall have
                      no other responsibility for ensuring the authenticity, validity or source of the E-Signature and shall have no
                      liability in respect of unauthorized, erroneous or fraudulent use of E-Signatures by your agents, offices employees
                      and representatives. CAL is not responsible for errors or failures from any malfunction of your computer hardware or
                      software.
                    </li>
                    <li>
                      CAL shall not be responsible for any loss or damage arising by any malfunctions or failure of the Facility or on the
                      failure or delay of CAL to act on instructions given via this medium.
                    </li>
                    <li>
                      CAL shall not be responsible for any loss or damage arising on account of any system, server or connection failure,
                      error, omission, interruption, delay in transmission, computer virus or other malicious, destructive or corrupting
                      code, agent program or macros.
                    </li>
                  </ol>
                </li>

                <li>
                  <p>
                    <b>IPO SERVICES </b>
                  </p>
                  <ol class="sub">
                    <li>
                      CAL shall not be subject to any liability whatsoever (whether in tort or contract or otherwise) for any loss, damage
                      or costs whatsoever suffered or incurred by you or any other person due to, as a consequence of or in connection with
                      any inaccuracies, changes, alterations, deletions or omissions in respect of the information provided in the
                      Prospectus and other related documentation (including, the IPO application) which may arise in connection with or as a
                      result of any fault or faults with web browsers or other relevant software, any fault or faults on yours or any third
                      party’s device, operating system or other software, viruses or other security threats and/or problems occurring during
                      data transmission; which may result in inaccurate or incomplete copies of information being downloaded or displayed on
                      a your device.
                    </li>

                    <li>
                      You shall hold CAL harmless from any damages, claims or losses whatsoever, as a consequence of or arising from using
                      the IPO facility or any rejection of your IPO Application for reasons of multiple application, suspected multiple
                      application, inaccurate and/or incomplete details provided by you, basis of allotment decided by the share issuing
                      company or any other cause beyond the control of CAL.
                    </li>
                    <li>
                      You agree to abide by any terms or regulations set forth by the Issuer or other regulatory bodies in connection with
                      the Application for the IPO, from time to time.
                    </li>
                  </ol>
                </li>

                <li>
                  <p>
                    <b>INDICATIVE DATA </b>
                  </p>
                  <ol class="sub">
                    <li>
                      That the portfolio balances and values shown on the Facility are indicative only and subject to change based on the
                      final valuations carried out by CAL, and shall not be construed as an official statement.
                    </li>
                    <li>
                      ASPI, S&P and other market data shown on the Facility here indicative only and are subject to change based on final
                      transactional data provided by the Colombo Stock Exchange and the Central Bank of Sri Lanka. This data can be subject
                      to delays and are not provided real time. CAL does not guarantee the accuracy of the same and this should not be
                      construed as official valuations or prices.
                    </li>
                  </ol>
                </li>

                <li>
                  <p><b> CHANGES TO TERMS </b></p>
                  <p>CAL reserves the right to vary these terms and conditions at any time and without prior notice to you.</p>
                </li>
                <li>
                  <p>
                    <b>DISPUTE RESOLUTION </b>
                  </p>
                  <p>
                    Any doubt, difference, dispute, controversy or claim arising from, out of or in connection with any contract between you
                    and us, or on the interpretation thereof or on the rights, duties, obligation, or liabilities of either party or on the
                    operation, breach, termination, validity thereof, shall be settled in a court of law in Sri Lanka.
                  </p>
                </li>

                <li>
                  <p><b>TERMINATION OF FACILITY</b></p>
                  <p>
                    CAL reserves the right to terminate your access to the Facility at any time without notice and without assigning any
                    reason therefor.
                  </p>
                </li>
              </ol>
            </div>
            <div class="col-12 info">
              <b [hidden]="dialogParams?.accept"
                >TO REGISTER AND ACCESS THE CAL PORTAL FACILITY, PLEASE INDICATE YOUR ACCEPTANCE AND CONSENT TO THE TERMS AND CONDITIONS OF
                THIS NOTICE BY CLICKING ON THE "I ACCEPT" BUTTON.</b
              >
            </div>
          </div>
          <div class="col-12 mt-4">
            <hr />
            <div class="col-12 mt-4">
              <h2 class="text-center">PRIVACY NOTICE</h2>
              <p class="heading">
                We, at Capital Alliance Investments Limited, Capital Alliance Securities (Pvt) Ltd and Capital Alliance PLC (hereinafter
                referred to as the “Company” “we” “us” and “our”), are steadfast in our commitment to respecting your privacy.
              </p>
              <p class="heading">
                While the group privacy policy applicable to Capital Alliance Holdings Limited and its subsidiaries – including the Company
                (hereinafter collectively referred to as the “Group”) is available on our website (accessible here [insert respective URL])
                and shall be deemed to be incorporated herein by reference, this Privacy Notice sets out some of the important terms and
                conditions upon which we shall process any personal data that you provide us with for the purpose of this application, as
                well as on your rights in respect of such personal data under applicable law – including, the Personal Data Protection Act,
                No. 09 of 2022 (the “PDPA”).
              </p>
            </div>
            <div class="col-12">
              <h4>Purpose of Processing your Personal Data</h4>
              <p>
                The collection of your personal data for the purposes of this application is an essential pre-requisite for us to provide
                you with our services (which include updating you on any additional or complimentary services provided by the Group), and
                the processing of such personal data is necessary for the effective fulfilment of our contractual obligation to you.
                Therefore, the non-disclosure of any personal data requested from you would preclude us from extending our services to you.
              </p>
              <p>
                The Company also has a legitimate interest in processing your personal data, such as for the purpose of pursuing any and all
                legal claims held by the Company pursuant to our contractual arrangement. Furthermore, the processing of your personal data
                is necessary for complying with applicable legal and regulatory requirements – including those imposed by the Colombo Stock
                Exchange, the Securities and Exchange Commission of Sri Lanka, the Inland Revenue Department, the Central Bank of Sri Lanka,
                etc.
              </p>
            </div>
            <div class="col-12">
              <h4>Types of personal data processed</h4>

              <p>In order to fulfil the purposes set out above, we process the following categories of personal data:</p>
              <ul>
                <li><b>Personal details</b> – including, for example, your name, date of birth and citizenship details;</li>
                <li>
                  <b>Contact details</b> – including, for example, your contact number, permanent address (including your status of
                  residency), correspondence address and email address;
                </li>
                <li>
                  <b>State issued identifications details</b> – including, for example, your national identity card or passport number;
                </li>
                <li>
                  <b>Financial details</b> – including, for example, your bank account details, bank statements, tax identification number,
                  source of income and billing proof; and
                </li>
                <li>
                  <b>Other details necessitated by applicable law</b> – including, for example, affiliations to any Politically Exposed
                  Persons (PEPs), your foreign account tax compliance status and other personal data that is statutorily required to be
                  collected as a part of the KYC process.
                </li>
              </ul>

              <p>
                Where and to the extent that: (a) the further collection of your personal data is deemed necessary for any of the purposes
                set out above; and / or (b) the collection and processing of “special categories of personal data” (as defined by the PDPA)
                is required for the aforementioned purposes, you will be notified accordingly.
              </p>
            </div>
            <div class="col-12">
              <h4>Retention period</h4>

              <p>
                We will process your personal data for as long as it is required to: (a) provide you with our services; (b) to comply with
                any legal or statutory obligations pertaining to your personal data; and / or (c) to respond to information requests by any
                legal or statutory body.
              </p>

              <p>
                Where and to the extent that your personal data is anonymized or tokenized, in a manner in which you are no longer
                personally identifiable through such data, you hereby agree grant us the right to utilize and process such data for any
                lawful purpose without any further notice to you.
              </p>
            </div>
            <div class="col-12">
              <h4>Transfer of personal data</h4>
              <p>
                Your personal data may be shared: (a) within the Group to facilitate the effective and seamless provision of our services;
                (b) with third parties for the purpose of ensuring the fulfilment of our contractual commitment to you (for example, with
                investment managers registered with the Securities and Exchange Commission of Sri Lanka, where applicable); (c) with service
                providers and business partners, to the limited extent required to effectively deliver our services to you; and (d) with
                legal and regulatory authorities, as and where required by law.
              </p>

              <p>
                For the purposes set out above in this Privacy Notice, your Personal Data may be transferred to, stored and maintained on
                servers and systems located outside of Sri Lanka. While the Company shall seek to adopt all reasonable and commercially
                acceptable technical, contractual and organizational means to protect the confidentiality and integrity of such Personal
                Data, you equally acknowledge: (a) that the Group cannot guarantee its absolute security, confidentiality and integrity; and
                (b) that the Group shall not be responsible for any loss of confidentiality and / or integrity arising from or in connection
                with the unlawful, malicious or negligent actions or omissions of a third party.
              </p>
            </div>
            <div class="col-12">
              <h4>Your rights</h4>
              <p>
                We encourage you to familiarise yourself with your rights as per our general privacy policy and the PDPA. Your rights in
                terms of the processing of your personal data by us include:
              </p>
              <ul>
                <li>The right to access and receive a copy of your personal data processed by us;</li>
                <li>The right to request the rectification of any inaccurate or incomplete personal data; and</li>
                <li>The right to request the erasure of your personal data, subject to the limitations provided by the PDPA.</li>
              </ul>
            </div>
            <div class="col-12">
              <h4>Contact us</h4>

              <p>
                If you have any further queries or concerns regarding the processing of your personal data by us, you may contact the Data
                Protection Authority of Sri Lanka. Respecting your privacy is integral to our ethos. For further details regarding the
                processing of your personal data or for the facilitation of your rights granted by the PDPA, please contact
                <a href="mailto:info&#64;calbd.com.bd">info&#64;calbd.com.bd</a>
              </p>
            </div>
          </div>
        </div>
        <div class="row" [hidden]="dialogParams?.accept">
          <div class="col text-right m-r">
            <button type="submit" (click)="accept()">I Accept</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
